import { WebStorageStateStore } from "oidc-client";
import { createUserManager } from "redux-oidc";
import { actionTypes } from "redux-query";
import { getConfig } from "./config-loader";
const authority = getConfig("REACT_APP_OIDC_AUTHORITY");
/*
 * The goal of the following code is to override fetch request
 * used by OIDC, to add withCredentials=true to force cookies to be sent
 * except on .well-known because the server returns AccessControlAllowOrigin:* for this request
 * and this is not compatible with withCredentials=true
 * ----
 * We should check if there is another way to do so with redux-oidc options directly.
 * Because oidc-client has a parameter fetchRequestCredentials that we should be able to leverage.
 * It can be used in "settings" below, but issue is that it also requests .well-known/configuration with credentials:include
 */
const { fetch: originalFetch } = window;
window.fetch = async (resource, config) => {
    let newConfig = config;
    // Intercept fetch request and add credentials: include
    if (resource && resource.toString().includes(authority) && !resource.toString().includes(".well-known")) {
        newConfig = { ...newConfig, credentials: "include" };
    }
    const response = await originalFetch(resource, newConfig);
    return response;
};
const locationPort = window.location.port ? `:${window.location.port}` : "";
/* eslint-disable camelcase */
const settings = {
    authority,
    automaticSilentRenew: true,
    client_id: getConfig("REACT_APP_OIDC_CLIENT_ID"),
    filterProtocolClaims: true,
    loadUserInfo: true,
    post_logout_redirect_uri: getConfig("REACT_APP_OIDC_POST_LOGOUT_URI"),
    prompt: "none",
    redirect_uri: `${window.location.protocol}//${window.location.hostname}${locationPort}/callback`,
    response_type: "code",
    scope: "openid profile offline_access",
    userStore: new WebStorageStateStore({ store: localStorage })
};
/* eslint-enable camelcase */
export const userManager = createUserManager(settings);
export const authMiddleware = (store) => (next) => (action) => {
    if (action && (action.type === actionTypes.MUTATE_ASYNC || action.type === actionTypes.REQUEST_ASYNC)) {
        const state = store.getState();
        if (state && state.auth && state.auth.oidc && state.auth.oidc.user && state.auth.oidc.user.access_token) {
            // This is a redux-query action so add the JWT header
            const options = action.options || {};
            const headers = options.headers || {};
            const updatedAction = {
                ...action,
                options: {
                    ...options,
                    headers: {
                        ...headers,
                        authorization: `Bearer ${state.auth.oidc.user.access_token}`
                    }
                }
            };
            // Let the action continue, but now with the JWT header.
            return next(updatedAction);
        }
    }
    // This isn't a redux-query action so just let it pass through
    return next(action);
};
